<template>
  <div>
    <div style="margin: 10px auto">绑定教职工身份信息</div>
    <!--   v-loading="loading" element-loading-text="正在自动填充"-->

    <div style="margin: 20px">
      教职工可以在咖啡厅选座，可以预约健身房17:00-18:00
    </div>
    <el-form ref="form" :model="form" label-width="100px">

      <el-form-item label="名字">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="所属单位">
        <el-input v-model="form.affiliation"></el-input>
      </el-form-item>
      <el-form-item label="昵称（选填）">
        <el-input v-model="form.nickname"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">立即绑定</el-button>
      </el-form-item>
    </el-form>

  </div>


</template>

<script>
import axios from '@/utils/request'

export default {
  name: 'Home',
  data() {
    return {
      form: {
        name: "",
        nickname: "",
        affiliation: ""

      },
      loading: false
    }
  },
  methods: {
    onSubmit() {
      axios.post("/newTeacherInfo", {
        name: this.form.name,
        affiliation: this.form.affiliation,
        nick: this.form.nickname
      }).then(res => {
        if (res.msg === "ok") {
          this.$router.push("/")
        }
      })
    }
  },
  mounted() {

  },
  created() {
    // axios.post("/getBindInfo").then(res => {
    //   if (res.data.Bind === "true") {
    //     setTimeout(() => {
    //       this.loading = false
    //       this.form.name = res.data.name
    //       this.form.xh = res.data.xh
    //       this.form.nickName = res.data.nickname
    //     }, 500)
    //
    //   } else {
    //     this.loading = false
    //   }


    // }
    // )
  }

}
</script>

<style scoped>
img {
  margin: 0;
  padding: 0;
}


.card {
  width: 80%;
  text-align: center;
  margin: 10px auto;
  font-family: "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}


</style>
